import api from '@/actions/api.actions'
import { store } from '@/store/store'

export default class consumerService {
  login (params) {
    return new Promise((resolve, reject) => {
      api.consumerLogin(params).then(response => {
        if (response.data.userId) {
          this.storeConsumerInfo(response.data)
          resolve()
        }
      }).catch(err => {
        reject(err)
      })
    })
  }

  register (params) {
    return new Promise((resolve, reject) => {
      api.consumerRegistration(params).then(response => {
        if (response.data.userId) {
          resolve()
        } else {
          reject('Something went wrong')
        }
      }).catch(err => {
        let errorMessage = this.handleError(err)
        reject(errorMessage)
      })
    })
  }

  forgetPwd (params) {
    return new Promise((resolve, reject) => {
      api.forgotPwd(params).then(response => {
        if (response.resetToken) {
          resolve(response)
        } else {
          resolve()
        }
      }).catch(err => {
        let errorMessage = this.handleError(err)
        reject(errorMessage)
      })
    })
  }

  resetPwd (params) {
    return new Promise((resolve, reject) => {
      api.resetPwd(params).then(response => {
        resolve()
      }).catch(err => {
        let errorMessage = this.handleError(err)
        reject(errorMessage)
      })
    })
  }

  storeConsumerInfo (consumerData) {
    store.commit('changeConsumerInfo', consumerData)
    store.commit('changeConsumerJwt', consumerData.startAccessJwt)
    let consumerBillingAddress = store.getters.consumerBillingAddress
    let consumerName = (consumerData.firstName + ' ' + consumerData.lastName).trim()
    if (!consumerBillingAddress['name']) {
      consumerBillingAddress['name'] = consumerName
      store.commit('changeConsumerBillingAddress', consumerBillingAddress)
    }
  }

  handleError (err) {
    let error = (err.response.data || {}).message || 'Something went wrong.'
    return error
  }
}
